export const environment = {
    production: false,
    uat: false,
    staging: true,
    baseUrl: "https://dev.api.raisingvoices.org/admin",
  
  };